import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';

import { RegistrationEdge } from '@app/registration/graph/graph-navigation.service';
import { HomepageNode } from '@app/registration/graph/nodes/homepage.node';

@Injectable({
  providedIn: 'root',
})
export class MarkRegAsyncToHomepageEdge implements RegistrationEdge {
  nextNode = HomepageNode;

  shouldNavigate$(): Observable<boolean> {
    return observableOf(true);
  }
}
